'use client';

import { cn, getInitials } from '@medizzconnect/shared';

interface AvatarProps {
  src?: string | null;
  alt?: string;
  firstName?: string | null;
  lastName?: string | null;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-16 w-16 text-lg',
} as const;

export function Avatar({ src, alt, firstName, lastName, size = 'md', className }: AvatarProps) {
  const initials = getInitials(firstName, lastName);

  if (src) {
    return (
      <img
        src={src}
        alt={alt ?? `${firstName ?? ''} ${lastName ?? ''}`.trim()}
        className={cn(
          'rounded-full object-cover',
          sizeClasses[size],
          className,
        )}
        loading="lazy"
      />
    );
  }

  return (
    <div
      className={cn(
        'rounded-full bg-primary-100 text-primary-700',
        'flex items-center justify-center font-semibold',
        sizeClasses[size],
        className,
      )}
      aria-label={alt ?? `${firstName ?? ''} ${lastName ?? ''}`.trim()}
    >
      {initials}
    </div>
  );
}
